import React from 'react';
import { Trans } from 'react-i18next';
import colours from './Colours';

// Headings
const Heading1 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '56px', lineHeight: '64px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const Heading2 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '48px', lineHeight: '56px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const Heading3 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '40px', lineHeight: '48px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const Heading4 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '32px', lineHeight: '40px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const Heading5 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '24px', lineHeight: '32px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const Heading6 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '20px', lineHeight: '24px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P1 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'normal', fontSize: '20px', lineHeight: '24px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P1Bold = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '20px', lineHeight: '24px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P1Link = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '20px', lineHeight: '24px', textDecorationLine: 'underline'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P2 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'normal', fontSize: '16px', lineHeight: '20px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P2Bold = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '16px', lineHeight: '20px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P2Link = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '16px', lineHeight: '20px', textDecorationLine: 'underline'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P3 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'normal', fontSize: '12px', lineHeight: '16px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P3Bold = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '12px', lineHeight: '16px', color: colours.primary.grey01}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P3Link = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '12px', lineHeight: '16px', textDecorationLine: 'underline'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P4 = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'normal', fontSize: '10px', lineHeight: '12px'}, props.style ? props.style : {})}>
            {props.children}
        </div>
    )
}

const P4Bold = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '10px', lineHeight: '12px'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const P4Link = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '10px', lineHeight: '12px', textDecorationLine: 'underline'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const CaptionLarge = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '12px', lineHeight: '14px', textTransform: 'uppercase', color: colours.primary.grey02}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const CaptionMedium = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '10px', lineHeight: '12px', textTransform: 'uppercase'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const CaptionSmall = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '8px', lineHeight: '10px', textTransform: 'uppercase', color: colours.primary.grey02}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const ButtonLarge = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: '900', fontSize: '16px', lineHeight: '24px', textAlign: 'center'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const ButtonMedium = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: '900', fontSize: '12px', lineHeight: '16px', textAlign: 'center'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const ButtonSmall = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: 'bold', fontSize: '10px', lineHeight: '12px', textAlign: 'center'}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

const InputLabel = (props) => {
    return (
        <div style={Object.assign({}, {fontFamily: 'Lato', fontWeight: '600', fontSize: '13px', lineHeight: '16px', color: colours.primary.grey01}, props.style ? props.style : {})} >
            {props.children}
        </div>
    )
}

export { 
    Heading1, Heading2, Heading3, Heading4, Heading5, Heading6,
    P1, P1Bold, P1Link, 
    P2, P2Bold, P2Link,
    P3, P3Bold, P3Link,
    P4, P4Bold, P4Link,
    CaptionLarge, CaptionMedium, CaptionSmall,
    ButtonLarge, ButtonMedium, ButtonSmall,
    InputLabel
     };